/**
 * Login screen color definitions
 */
import { palette, createColor } from './palette.colors';

export const loginColors = {
  mainBGColor: createColor(palette.blue.appBG, palette.dark.background),
  contentBGColor: createColor(palette.gray.white, palette.dark.content),
  pageBackground: createColor(palette.special.transparent, palette.opacity.white08),
  pageBorder: createColor(palette.borders.dropdownBlue, palette.opacity.white06),
  headerText: createColor(palette.blue.onTint, palette.gray.white),
  textColor: createColor(palette.gray.fieldAlt, palette.gray.white),
  dotsColor: createColor(palette.gray.dots, palette.gray.white),
  actionsTextColor: createColor(palette.gray.darker, palette.dark.textAlt),
  forgotPassWordText: createColor(palette.blue.secondary, palette.blue.light),
  shadowColor: createColor(palette.special.shadow, palette.opacity.white20),
  pageSelectedTextColor: createColor(palette.gray.darkest, palette.gray.white),
  headerModalText: createColor(palette.gray.darkest, palette.gray.darkest),
};